module.exports = __webpack_public_path__ + "static/img/bg7.c344a7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/auth/img/bg/bg7.jpg
// module id = 1054
// module chunks = 17